<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Date Range:</span>
            <el-date-picker
              v-model="filter.dateRange"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              :disabled-date="disabledDate"
              @change="handleDateChange"
            >
            </el-date-picker>
          </div>
          <div class="filter-item">
            <span class="title">Brand:</span>
            <el-select v-model="brandId" filterable @change="handleBrand">
              <el-option v-for="(item) in brands" :key="item._id" :label="item.name" :value="item._id"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="title">Product:</span>
            <el-select v-model="productId" filterable @change="handleProduct">
              <el-option label="All" value=""></el-option>
              <el-option v-for="(item) in products" :key="item._id" :label="item.general.model" :value="item._id"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="main-table">
        <el-tabs type="border-card" :model-value="currentTab" @tab-click="handleTabClick">
          <el-tab-pane label="Played Times" name="play_times">
            <div class="main-filters" style="padding-bottom: 10px; margin-top: 15px;">
              <span>Total Number: {{ totalNum.playTimes }}</span>
            </div>
            <el-alert :title="tabTitles.playTimes" type="info" show-icon></el-alert>
            <div class="main-table" v-loading="flagLoading.getPlayTimes">
              <div id="chart_play_times"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Listening Time" name="listening_time">
            <div class="main-filters" style="padding-bottom: 10px; margin-top: 15px;">
              <span>Total Time: {{ generateTimeHMS(totalNum.listeningTime) }}</span>
            </div>
            <el-alert :title="tabTitles.listeningTime" type="info" show-icon></el-alert>
            <div class="main-table" v-loading="flagLoading.getListeningTime">
              <div id="chart_listening_time"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])
export default {
  name: 'StatisticsProducts',
  components: {
  },
  data () {
    const flagLoading = reactive({
      getPlayTimes: false,
      getListeningTime: false
    })
    const today = new Date()
    const start = new Date(today.getTime() - (13 * 24 * 60 * 60 * 1000))
    const filter = reactive({
      dateRange: [start, today]
    })
    const chartsData = reactive({
      playTimes: { xAxis: [], series: [] },
      listeningTime: { xAxis: [], series: [] }
    })
    const tabTitles = {
      playTimes: 'Count the number of product play times.',
      listeningTime: 'Total time for users to listen to the product.'
    }
    const totalNum = reactive({
      playTimes: 0,
      listeningTime: 0
    })
    return {
      currentTab: 'play_times',
      brands: [],
      products: [],
      brandId: '',
      productId: '',
      chartPlayTimes: null,
      chartListeningTime: null,
      flagLoading,
      filter,
      chartsData,
      tabTitles,
      totalNum
    }
  },
  created: async function () {
    this.getBrands()
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      currentRole: 'currentRole'
    })
  },
  watch: {
  },
  methods: {
    getBrands: function () {
      const url = '/api/v1/atk_player/admin/brands?page_num=1&page_size=1000&is_deleted=false'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            that.brands = res.data.list
            that.brandId = that.brands[0]._id
            that.getProducts()
          }
        }
      }).catch(function (err) {
        console.error('getBrands', err)
      })
    },
    getProducts: function () {
      const url = `/api/v1/atk/admin/products?is_deleted=false&page_num=1&page_size=1000&brand_id=${this.brandId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            that.products = res.data.list
          } else {
            that.products = []
          }
          that.productId = ''
          switch (that.currentTab) {
            case 'play_times':
              that.getPlayTimes()
              break
            case 'listening_time':
              that.getListeningTime()
              break
          }
        }
      }).catch(function (err) {
        console.error('getProducts', err)
      })
    },
    generateDates: function (start, end) {
      const dates = []
      const currentDate = new Date(start)
      while (currentDate <= new Date(end)) {
        dates.push(this.formatDate(currentDate))
        currentDate.setDate(currentDate.getDate() + 1)
      }
      return dates
    },
    formatDate: function (date) {
      date = new Date(date)
      let month = '' + (date.getMonth() + 1)
      let day = '' + date.getDate()
      const year = date.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    setChartPlayTimes: function (id, data) {
      const chart = echarts.init(document.getElementById(id))
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Total Count',
            data: data.series,
            type: 'bar'
          }
        ]
      }
      chart.setOption(option, true)
      return chart
    },
    updateChartPlayTimes: function () {
      this.$nextTick(() => {
        if (this.chartPlayTimes) this.chartPlayTimes.dispose()
        this.chartPlayTimes = this.setChartPlayTimes('chart_play_times', this.chartsData.playTimes)
      })
    },
    setChartListeningTime: function (id, data) {
      const chart = echarts.init(document.getElementById(id))
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Total Time(s)',
            data: data.series,
            type: 'bar'
          }
        ]
      }
      chart.setOption(option, true)
      return chart
    },
    updateChartListeningTime: function () {
      this.$nextTick(() => {
        if (this.chartListeningTime) this.chartListeningTime.dispose()
        this.chartListeningTime = this.setChartListeningTime('chart_listening_time', this.chartsData.listeningTime)
      })
    },
    getPlayTimes: function () {
      this.flagLoading.getPlayTimes = true
      const dateStart = this.formatDate(this.filter.dateRange[0])
      const dateEnd = this.formatDate(this.filter.dateRange[1])
      let url = `/api/v1/atk/admin/statistics/product/play?widget_type=mobile&start=${dateStart}&end=${dateEnd}&brand_id=${this.brandId}`
      if (this.productId) url += `&product_id=${this.productId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.chartsData.playTimes = {
            xAxis: that.generateDates(dateStart, dateEnd),
            series: res.data.series
          }
          that.totalNum.playTimes = res.data.total_num
          that.updateChartPlayTimes()
        }
        that.flagLoading.getPlayTimes = false
      }).catch(function (err) {
        console.error('getPlayTimes', err)
        that.flagLoading.getPlayTimes = false
      })
    },
    getListeningTime: function () {
      this.flagLoading.getListeningTime = true
      const dateStart = this.formatDate(this.filter.dateRange[0])
      const dateEnd = this.formatDate(this.filter.dateRange[1])
      let url = `/api/v1/atk/admin/statistics/product/listening_time?widget_type=mobile&start=${dateStart}&end=${dateEnd}&brand_id=${this.brandId}`
      if (this.productId) url += `&product_id=${this.productId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.chartsData.listeningTime = {
            xAxis: that.generateDates(dateStart, dateEnd),
            series: res.data.series
          }
          that.totalNum.listeningTime = res.data.total_num
          that.updateChartListeningTime()
        }
        that.flagLoading.getListeningTime = false
      }).catch(function (err) {
        console.error('getListeningTime', err)
        that.flagLoading.getListeningTime = false
      })
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    disabledDate: function (time) {
      return time.getTime() > Date.now()
    },
    handleDateChange: function (dates) {
      switch (this.currentTab) {
        case 'play_times':
          this.getPlayTimes()
          break
        case 'listening_time':
          this.getListeningTime()
          break
      }
    },
    handleBrand: function (brandId) {
      this.brandId = brandId
      switch (this.currentTab) {
        case 'play_times':
          this.getProducts()
          break
        case 'listening_time':
          this.getProducts()
          break
      }
    },
    handleProduct: function () {
      switch (this.currentTab) {
        case 'play_times':
          this.getPlayTimes()
          break
        case 'listening_time':
          this.getListeningTime()
          break
      }
    },
    handleTabClick: function (tab) {
      this.currentTab = tab.props.name
      switch (this.currentTab) {
        case 'play_times':
          this.getPlayTimes()
          break
        case 'listening_time':
          this.getListeningTime()
          break
      }
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    generateTimeHMS: function (time) {
      const h = Math.floor(time / 3600).toString().padStart(2, '0')
      const m = Math.floor(time % 3600 / 60).toString().padStart(2, '0')
      const s = Math.floor(time % 60).toString().padStart(2, '0')
      return h + ':' + m + ':' + s
    }
  }
}
</script>
<style scoped>
  .main-filters {
    border: solid 1px #EEEEEE;
    padding: 10px 10px 0;
  }
  #chart_play_times, #chart_listening_time {
    width: 100%;
    height: 500px;
    border: solid 1px #EEEEEE;
  }
</style>
